import { useTranslation } from "react-i18next";
import bg1 from "../assests/solutions/cust-1.webp";
import bg1ar from "../assests/solutions/SOE-2.jpg";

import bg2 from "../assests/solutions/SOE-3.webp";
import bg from "../assests/solutions/cloud-9.jpeg"
import './SOE.css';

import Approach from "./Approach";
import ZigZag from "./ZigZag";
import img1 from "../assests/solutions/customer.webp";
import img2 from "../assests/solutions/cust-img2.webp";
import Partnerships from "./Partnerships";
import logo1 from "../assests/solutions/img1.png";
import logo2 from "../assests/solutions/img2.png";
import logo3 from "../assests/solutions/img3.png";
import logo4 from "../assests/solutions/img4.png";
import Header from "../Home/Header";
import Footer from "../Footer/Footer";

const CustomerExp = () => {

    const { i18n } = useTranslation();
    const isArabic = i18n.language === "ar";
    const approachItems = [
        {
            step: 1,
            title: "Business Understanding",
            description: "Business understanding to deliver high impact solution",
        },
        {
            step: 2,
            title: "Requirements Elicitation",
            description: "Gather business requirements to provide the best solution",
        },
        {
            step: 3,
            title:"Design Thinking",
            description: "Ideate, design and create the best solutions",
        },
        {
            step: 4,
            title: "Workshop",
            description: "Detailed business workshops to identify gaps",
        },
        {
            step: 5,
            title: "Development",
            description: "Utilize Best Practices for Solution Development",
        },
        {
            step: 6,
            title: "Deployment",
            description: "Deploy Solution with high flexibility & scalability",
        },

    ];

    return (
        <>
            <div className="hd">
                <Header />
            </div>
            <section
                className="main-hero"
                style={{
                    backgroundImage: `url(${isArabic ? bg1ar : bg1})`
                }}

            >
                <div className="main-overlay" />

                <div className="main-hero-content" data-aos="fade-up" style={{ paddingLeft: isArabic ? "0px" : "70px", paddingRight: isArabic ? "70px" : "0px" }}>
                    <h1 className="main-title" style={{color:"black"}}>
                        Customer Experience
                    </h1>

                    <p className="main-subtitle" style={{color:"black"}}>
                        Elevating customer experience through engagement, innovation and excellence

                    </p>
                </div>

            </section>

            <section className="cust-info-split container">
                <div className="cust-info-text" data-aos="fade-right">
                    <p>TTH's business transformation approach includes strategic involvement with our customer’s teams to achieve business benefits.  From modernizing legacy business applications for improved productivity to enabling people practices with AGILE methods, we help transform your business to scale for future!</p>
                    <p>Our Expertise: SAFE | AGILE Strategy | Assessment | Roadmap | Cloud Readiness | Migration | Upgrade | Reporting & Data Analytics | Integration with 3rd party systems | Modern UI.UX with Systems of Records | Managed Services & Support</p>
                </div>

                <div className="cust-info-image" data-aos="fade-left">
                    <img src={bg2} alt="Customer Experience" />
                </div>
            </section>


            <ZigZag
                title="E-Commerce"
                description="TTH'S e-commerce services provide end-to-end capabilities which include building new websites on platforms like WordPress, Magento, Woocommerce, or Noopcommerce, along with cataloging, merchandising, content management services, and omnichannel capabilities. Our approach has proven to be rewarding for e-commerce companies with a full-fledged IT ecosystem. Thus, we introduce a new level of customer service, resource planning, order processing, and other vital aspects. We provide a broad range of e-commerce services-"
                image={img1}
            >
                <h5>IdentifyMarket & Strategies</h5>
                <ul>
                    <li>Identify gaps, customer needs & pricing</li>
                </ul>

                <h5>Selection and Implementation of E-Commerce</h5>
                <ul>
                    <li>TTH will provide recommendations and will implement the platform</li>
                </ul>

                <h5>eCommerce Hosting & Testing</h5>
                <ul>
                    <li>E-Commerce Functionality Testing and Load Testing</li>
                    <li>Recommendation Engine – Cross-Selling and Upselling</li>
                </ul>
            </ZigZag>

            <ZigZag
                title="WEB"
                description="TTH Develops professional, engaging & simple to use websites for businesses & organizations with benefits like on-time delivery, user-friendliness & a fast loading website. We provide custom web development services from end-to-end, including ground-up web development, migration, updating, and ongoing maintenance services. Our developer’s expertise & experience and state-of-the-art technologies will bring Robust Web Applications to you. We have expertise in:"
                image={img2}
            >
                <h5>Strategic Analysis & Planning</h5>
                <ul>
                    <li>Requirement Gathering</li>
                    <li>Insights</li>
                    <li>Qualitative & Quantitative Reports</li>
                    <li>Defining New Requirements (blogs, videos, website navigation flow, newsletter, user-management, etc.)</li>

                </ul>

                <h5>Information Architecture</h5>

                <ul>
                    <li>Focus on making website easily navigable</li>
                    <li>Micro conversions</li>

                </ul>
            </ZigZag>


            <Approach
                title="Approach"
                data-aos="fade-up"
                backgroundImage={bg}
                items={approachItems}
            />


            <Partnerships
                title="Partnerships"
                subtitle="We have a robust ecosystem of ISVs to support our solutions and services"
                partners={[
                    { name: "SAP S/4HANA", logo: logo1 },
                    { name: "Oracle JD Edwards", logo: logo2 },
                    { name: "Microsoft Dynamics 365", logo: logo3 },
                    { name: "Infor", logo: logo4 },
                ]}
            />

            <Footer />
        </>
    );
};

export default CustomerExp;